export function createWindowDeferred() {
  const handle = window.open();

  return [
    (url: string) => {
      handle.opener = null;
      handle.location = url;
    },
    () => {
      handle.close();
    },
  ];
}
